import { CourseSection } from "@domain/lms/course/courseSection";

export abstract class SectionController<T extends CourseSection> {
	constructor(
		protected readonly sectionUpdater: (update: (section: T) => T) => void,
		public readonly removeSection: () => void
	) {}
}
